module.exports = __webpack_public_path__ + "img/star5-10.4253f5c5.svg";